var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page_top"},[_vm._m(0),_c('div',{staticClass:"pay_desc"},[_vm._v(" 支付成功! ")]),_c('van-button',{staticClass:"complete",attrs:{"type":"primary"},on:{"click":_vm.complete}},[_vm._v("完成")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay_icon"},[_c('img',{attrs:{"src":require("@/assets/image/paysuc.png"),"alt":""}})])
}]

export { render, staticRenderFns }